import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	updateDescriptionAndRetry: {
		id: 'ai-related-issues.find-similar-work-items.update-description-and-retry',
		defaultMessage: 'Update description and retry',
		description: 'Error message shown when there is a problem with the Atlassian Intelligence call',
	},
	noSimilarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.no-similar-work-items',
		defaultMessage: 'No similar work items',
		description: 'Message shown when no similar work items are found',
	},
	similarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.similar-work-items',
		defaultMessage: 'Similar work items',
		description: 'Title of the collapsible parent',
	},
	showNumResults: {
		id: 'ai-related-issues.find-similar-work-items.show-results',
		defaultMessage: 'Show {numResults} {numResults, plural, one {result} other {results}}',
		description: 'Button text to show the number of results of linked work items',
	},
	linkSimilarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.link-similar-work-items',
		defaultMessage: 'Link similar work items',
		description: 'An updated title of the collapsible parent',
	},
	searchingForSimilarWorkItems: {
		id: 'ai-related-issues.find-similar-work-items.searching-for-similar-work-items',
		defaultMessage: 'Searching for similar work items',
		description: 'Title of the collapsible parent when the AI is searching for similar work items',
	},
	searchAgain: {
		id: 'ai-related-issues.find-similar-work-items.search-again',
		defaultMessage: 'Search again',
		description: 'Button text to search for items again',
	},

	similarIssuesCouldNotBeGenerated: {
		id: 'ai-related-issues.page-suggestions-could-not-be-generated',
		defaultMessage: "Atlassian Intelligence couldn't find issues similar to this one",
		description: 'Message shown when AI cannot suggest similar issues to the issue',
	},
	similarIssuesCouldNotBeGeneratedIssueTermRefresh: {
		id: 'ai-related-issues.page-suggestions-could-not-be-generated-issue-term-refresh',
		defaultMessage: "Atlassian Intelligence couldn't find work items similar to this one",
		description: 'Message shown when AI cannot suggest similar work items to the work item',
	},
});
